module.exports = __webpack_public_path__ + "static/img/11.bb8c583.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/11.png
// module id = Xt3f
// module chunks = 0